<template>
    <ModalBase
        name="generar-excel-asientos"
        title="Generar excel de asientos"
        @close="close()"
    >
        <div data-cy="modal-generar-excel" class="tw:flex tw:flex-col tw:items-center tw:gap-4">
            <h1 class="tw:font-bold tw:text-center">
                ¿Quieres generar un excel con el detalle de todos los asientos del recinto?
            </h1>
            <Button
                type="button"
                variant="primary"
                customClass="tw:bg-green-600 tw:hover:bg-green-700 tw:text-white tw:font-semibold tw:px-4 tw:py-2 tw:rounded tw:ml-2"
                data-cy="btn-confirmar-generar-excel"
                :disabled="loading"
                @click="confirmar"
            >
                SI, GENERAR
            </Button>
        </div>
        <template #footer>
            <Button type="button" @click.prevent="close()">CERRAR</Button>
        </template>
    </ModalBase>
</template>

<script setup>
    import { useGenerarExcelAsientos } from '@/composables/admin/abonos/useGenerarExcelAsientos';
    import { useToast } from '@/composables/common/useToast';
    import ModalBase from '@/modules/admin/ui/ModalBase';
    import Button from '@/modules/admin/ui/Button';

    const { loading, generar } = useGenerarExcelAsientos();
    const toast = useToast();

    const emit = defineEmits(['close']);

    const close = () => {
        emit('close', 'generar-excel-asientos');
    };

    const confirmar = async() => {
        const res = await generar();
        if (res.ok) {
            toast.success('Excel en generación. Recibirás una notificación cuando esté listo.');
            close();
        }
    };
</script>
